import React from "react";
import stylesV2 from "./ThankYou.module.scss";
import stylesV3 from "./ThankYouV2.module.scss";
import { Button } from "components/Button";
import { useSchedulingABVariant } from "../../utils/useSchedulingABVariant";

export const waitlistThankYouAria = {
  describedby: "waitlist-thank-you-description",
};

export const ThankYou: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const { isV3 } = useSchedulingABVariant();
  const styles = isV3 ? stylesV3 : stylesV2;
  return (
    <div className={styles.thankYou}>
      <p id={waitlistThankYouAria.describedby} className={styles.note}>
        Thank you for submitting your email!
        <br />
        We encourage booking with a nearby office or choosing the best possible
        time available.
      </p>
      <Button
        className={styles.button}
        text={"Continue Scheduling"}
        size="large"
        onClick={onClose}
      />
    </div>
  );
};
